import { Service2026Details } from "../../../types/servicePackageType";
import { 가족장2026 } from "./가족장";
import { 무빈소장2026 } from "./무빈소장";
import { 일반장2026 } from "./일반장";
import { 가족장프리미엄2026 } from "./가족장프리미엄";
import { 일반장프리미엄2026 } from "./일반장프리미엄";

import { PAYBK289V2 } from "./PAYBK289V2";
import { PAYBK289V6 } from "./PAYBK289V6";

export const SERVICE_DETAILS_2026_BASE: Record<
  "무빈소장" | "가족장" | "일반장",
  Service2026Details
> = {
  무빈소장: 무빈소장2026,
  가족장: 가족장2026,
  일반장: 일반장2026,
};

export const SERVICE_DETAILS_2026: Record<
  "무빈소장" | "가족장" | "일반장" | "가족장 프리미엄" | "일반장 프리미엄",
  Service2026Details
> = {
  ...SERVICE_DETAILS_2026_BASE,
  ["가족장 프리미엄"]: 가족장프리미엄2026,
  ["일반장 프리미엄"]: 일반장프리미엄2026,
};

export const OPERATION_SERVICE_DETAILS_2026: Record<
  "1만원납입_10만원할인" | "3만원납입_10만원할인",
  Service2026Details
> = {
  "1만원납입_10만원할인": PAYBK289V2,
  "3만원납입_10만원할인": PAYBK289V6,
};
